import client from './reportsClient';
import { mapCatalog, mapReport, mapNode, mapFavorites, reportSlug, FAVORITE_TYPES } from '../models/reportMappers';
import { safeUrl } from '../models/reportContent';

export class ReportsRepository {
  constructor(http = client) { this.http = http; this.pending = new Map(); this.active = 0; this.queue = []; }
  async limitedRead(path) {
    if (this.active >= 4) await new Promise(resolve => this.queue.push(resolve));
    else this.active++;
    try { return await this.http.get(path); }
    finally { const next = this.queue.shift(); if (next) next(); else this.active--; }
  }
  async catalog(page = 0) { return mapCatalog((await this.http.get(`/api/informes/${Math.max(0, Number(page) || 0)}`)).data); }
  async archive() { const response = await this.http.get('/api/informes-list'); return (Array.isArray(response.data) ? response.data : []).map(mapReport).filter(item => item.slug); }
  async report(slug) {
    if (!reportSlug(slug)) { const error = new Error('El enlace del informe no es válido.'); error.status = 404; throw error; }
    return mapReport((await this.http.get(`/api/informe/${encodeURIComponent(slug)}`)).data);
  }
  async favorites() { return mapFavorites((await this.http.get('/eurekers/vdb/informe-favourites')).data); }
  async setFavorite(type, id, enabled) {
    if (!FAVORITE_TYPES.includes(type) || !/^\d+$/.test(String(id))) throw new Error('Este contenido no admite favoritos.');
    const body = new URLSearchParams({ folder_name: type, informe_id: String(id) });
    await this.http.post(`/eurekers/vdb/informe-favourites/${enabled ? 'add' : 'remove'}`, body, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  async section(section, slug) {
    if (section.restricted) return [];
    return Promise.all(section.refs.map(async id => {
      if (String(id) === '-1') return { restricted: true };
      if (section.type === 'satira') return { type: 'satira', image: safeUrl(id), charts: [], tables: [] };
      try {
        if (!/^\d+$/.test(String(id))) throw new Error('Referencia de contenido no válida.');
        if (!reportSlug(slug)) throw new Error('El enlace del informe no es válido.');
        const key = `${slug}/${id}`;
        if (!this.pending.has(key)) this.pending.set(key, this.limitedRead(`/api/frontend/v1/reports/${encodeURIComponent(slug)}/nodes/${id}`).finally(() => this.pending.delete(key)));
        const raw = (await this.pending.get(key)).data;
        if (!raw || raw.error) throw new Error('No se pudo cargar esta sección del informe.');
        const block = mapNode(raw, section.type);
        if (section.type === 'direccionalidad' && block.directionDate) {
          const kinds = [['histograma1', 'Nuevos máximos y mínimos'], ['histograma2', 'Nuevos máximos y mínimos · últimas semanas'], ['pie', 'Máximos y mínimos · última semana'], ['pieupdown', 'Valores alcistas y bajistas']];
          const charts = await Promise.all(kinds.map(async ([kind, title]) => {
            try { const response = await this.limitedRead(`/graficos/${kind}/${block.directionDate}`); return { key: kind, kind: kind.startsWith('pie') ? 'pie' : 'column', title, data: response.data }; }
            catch (error) { return { key: kind, title, error: error.message }; }
          }));
          return { ...block, charts };
        }
        return block;
      } catch (error) { return { error: error.message, restricted: error.status === 403 }; }
    }));
  }
}
export default new ReportsRepository();
